{
  "id": "campaign-024",
  "name": "Bushy Park",
  "seed": "campaign:24",
  "startDir": "E",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    ",,,,,,,#....",
    ",,,,,,,,....",
    ",,,,...,,...",
    "ww,.....,,,,",
    "ww,.h..h,,,,",
    ",,,.....,,,,",
    "____________",
    "........,,,,",
    "....,...,,,,",
    "x,,,#,,,,~,,",
    ",,,,,,,,~~~,",
    ",,,ss,,,,~,,",
    ",,bss,...b,,",
    "..,,,.....,,",
    "S...,.....,,"
  ],
  "critters": [
    {
      "kind": "squirrel",
      "x": 9,
      "y": 13
    },
    {
      "kind": "squirrel",
      "x": 1,
      "y": 7
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 9,
      "y": 5
    },
    {
      "kind": "gas",
      "x": 2,
      "y": 13
    },
    {
      "kind": "gas",
      "x": 3,
      "y": 1
    },
    {
      "kind": "coin",
      "x": 2,
      "y": 6
    },
    {
      "kind": "coin",
      "x": 8,
      "y": 6
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 6
    },
    {
      "kind": "coin",
      "x": 11,
      "y": 11
    },
    {
      "kind": "coin",
      "x": 11,
      "y": 13
    },
    {
      "kind": "coin",
      "x": 0,
      "y": 0
    },
    {
      "kind": "rare",
      "x": 4,
      "y": 6
    }
  ],
  "generatorVersion": 3,
  "level": 24,
  "biome": "park",
  "par": {
    "reel": 13051,
    "push": 8292,
    "selfPropelled": 7593,
    "tractor": 4421,
    "zeroTurn": 5105,
    "fairway": 3109
  },
  "routeTries": {
    "par": {
      "reel": 0,
      "push": 12,
      "selfPropelled": 3,
      "tractor": 0,
      "zeroTurn": 1,
      "fairway": 23
    }
  }
}
